import CommonUtils from '@/resources/utils/common-utils'
import API from '@/config/api'

const questionApi = {
    state: {},

    mutations: {
        getProductCateLists(state, data) {
            data.url = API.product.getProductCateLists
            CommonUtils.GetRequest(data)
        },
        getProductCateListsByCps(state, data) {
            data.url = API.product.getProductCateListsByCps
            CommonUtils.GetRequest(data)
        },
        getProductCateListsByCore(state, data) {
            data.url = API.product.getProductCateListsByCore
            CommonUtils.GetRequest(data)
        },
        addProductCateByLevel(state, data) {
            data.url = API.product.addProductCateByLevel
            CommonUtils.PostRequest(data)
        },
        delProductCateById(state, data) {
            data.url = API.product.delProductCateById
            CommonUtils.GetRequest(data)
        },
        editProductCateByLevel(state, data) {
            data.url = API.product.editProductCateByLevel
            CommonUtils.PostRequest(data)
        },
        addOrEditMaterialCategory(state, data) {
            data.url = API.product.addMaterialCategory
            CommonUtils.PostRequest(data, true)
        },
        getMaterialCategoryList(state, data) {
            data.url = API.product.getMaterialCategoryList
            CommonUtils.GetRequest(data)
        },
        addMaterialImg(state, data) {
            data.url = API.product.addMaterialImg
            CommonUtils.PostRequest(data, true)
        },
        getMaterialImgList(state, data) {
            data.url = API.product.getMaterialImgList
            CommonUtils.GetRequest(data)
        },
        getMaterialRelativeProductList(state, data) {
            data.url = API.product.getMaterialRelativeProductList
            CommonUtils.GetRequest(data)
        }
    }
}

export default questionApi



// WEBPACK FOOTER //
// ./src/store/modules/product.js